import { render } from "./Dj.vue?vue&type=template&id=11313ced&scoped=true"
import script from "./Dj.vue?vue&type=script&lang=js"
export * from "./Dj.vue?vue&type=script&lang=js"

import "./Dj.vue?vue&type=style&index=0&id=11313ced&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11313ced"]])

export default __exports__